import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "p-4 border bg-success/30 border-gray-200 rounded-md w-2/6 border-0" }
const _hoisted_2 = { class: "flex justify-center items-center" }
const _hoisted_3 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_4 = ["onUpdate:modelValue", "name"]
const _hoisted_5 = ["for"]
const _hoisted_6 = ["onUpdate:modelValue", "name"]
const _hoisted_7 = ["for"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DetailsModalForm = _resolveComponent("DetailsModalForm")!
  const _component_Selector = _resolveComponent("Selector")!
  const _component_TextField = _resolveComponent("TextField")!
  const _component_TableBase = _resolveComponent("TableBase")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Modal, {
      title: "Formulario",
      visible: _ctx.showModal,
      nestedModalOpen: _ctx.showDetails,
      "onUpdate:visible": _cache[2] || (_cache[2] = (e) => _ctx.showModal = e),
      onClose: _ctx.cancelModal
    }, {
      footer: _withCtx(() => [
        _createElementVNode("button", {
          class: "bg-success hover:bg-green-500 text-white font-bold py-2 px-4 rounded",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.saveForm && _ctx.saveForm(...args)))
        }, "Enviar")
      ]),
      default: _withCtx(() => [
        (_ctx.showDetails)
          ? (_openBlock(), _createBlock(_component_DetailsModalForm, {
              key: 0,
              visible: _ctx.showDetails,
              blockId: _ctx.blockId,
              index: _ctx.indexDetails,
              questions: _ctx.questions,
              onCloseModal: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showDetails = false)),
              data: _ctx.dataAnswer,
              onCreate: _ctx.responseUpdate
            }, null, 8, ["visible", "blockId", "index", "questions", "data", "onCreate"]))
          : _createCommentVNode("", true),
        _createVNode(_component_TableBase, {
          title: _ctx.formTitle,
          class: "mt-5"
        }, {
          body: _withCtx(() => [
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questions, (question, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  class: "text-left",
                  key: question.id
                }, [
                  _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                  _createElementVNode("td", null, _toDisplayString(question.content), 1),
                  _createElementVNode("td", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                      (question.answerTypeFront == 'RADIAL')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _withDirectives(_createElementVNode("input", {
                              id: "bordered-radio-1",
                              type: "radio",
                              "onUpdate:modelValue": ($event: any) => ((question.responseForm) = $event),
                              value: "true",
                              name: 'bordered-radio-' + question.id,
                              class: "w-4 h-4 text-success bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-success dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                            }, null, 8, _hoisted_4), [
                              [_vModelRadio, question.responseForm]
                            ]),
                            _createElementVNode("label", {
                              for: 'bordered-radio-1-' + question.id,
                              class: "ml-2 mr-4 text-sm font-medium text-success"
                            }, "Si", 8, _hoisted_5),
                            _withDirectives(_createElementVNode("input", {
                              id: "bordered-radio-2",
                              type: "radio",
                              "onUpdate:modelValue": ($event: any) => ((question.responseForm) = $event),
                              value: "false",
                              name: 'bordered-radio-' + question.id,
                              class: "w-4 h-4 text-success bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-success dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                            }, null, 8, _hoisted_6), [
                              [_vModelRadio, question.responseForm]
                            ]),
                            _createElementVNode("label", {
                              for: 'bordered-radio-2-' + question.id,
                              class: "ml-2 text-sm font-medium text-success"
                            }, "No", 8, _hoisted_7)
                          ]))
                        : _createCommentVNode("", true),
                      (question.answerTypeFront == 'SELECTOR')
                        ? (_openBlock(), _createBlock(_component_Selector, {
                            key: 1,
                            class: "w-3/4 mr-6",
                            selectedItem: Number(_ctx.tipoSelector),
                            items: _ctx.formSelector,
                            onUpdate: _ctx.onUpdateSelector
                          }, null, 8, ["selectedItem", "items", "onUpdate"]))
                        : _createCommentVNode("", true),
                      (question.answerTypeFront == 'INPUT')
                        ? (_openBlock(), _createBlock(_component_TextField, {
                            key: 2,
                            class: "w-3/4 mr-6",
                            placeholder: 'Escribir Tipo',
                            type: "numeric",
                            model: question.responseForm,
                            "onUpdate:model": ($event: any) => ((question.responseForm) = $event),
                            name: 'text' + question.id
                          }, null, 8, ["model", "onUpdate:model", "name"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  (!question.isCondition)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _withModifiers(($event: any) => (_ctx.details(index)), ["stop"]),
                        class: "cursor-pointer flex ml-2 my-2 rounded-md text-white bg-success hover:bg-green-600 focus:bg-green-600 px-2 py-2"
                      }, " Ver detalles ", 8, _hoisted_8))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ]),
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }, 8, ["title"])
      ]),
      _: 1
    }, 8, ["visible", "nestedModalOpen", "onClose"])
  ]))
}